// extracted by mini-css-extract-plugin
export default {"auditEvents":"AuditEventsDetail_auditEvents__X6P9y"};